import { NextPage } from 'next';
import { useRouter } from 'next/router';
import Head from 'next/head';
import styled from '@emotion/styled';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useToggle } from '@hooks/toggle/useToggle';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import Title from '@components/_atoms/Title';
import withAuth from '@components/hocs/withAuth';
import SignOutContent from '@components/_templates/user/SignOutContent';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { useTranslation } from 'next-i18next';

const SignOutWrapper = styled.div`
  width: 100%;
  max-width: 712px;
  padding: 110px 0;
  margin: 0 auto;

  @media ${TABLET_MODE} {
    max-width: 424px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 40px;
`;

const SignOut: NextPage = () => {
  const { t } = useTranslation('user');
  return (
    <>
      <Head>
        <title>스틸보소 : 회원 탈퇴</title>
        <meta name="title" content="스틸보소 : 회원 탈퇴" />
      </Head>
      <DefaultLayout>
        <SignOutWrapper>
          <TitleWrapper>
            <Title content={t('signout.title')} />
          </TitleWrapper>

          {/* SignOutContent */}
          <SignOutContent />
          {/* SignOutContent end */}
        </SignOutWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['user', 'common', 'component'])),
  },
});

export default withAuth(SignOut);
